import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import Footer from './Footer';

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <>
      <style>{`
       .admin-layout { display: flex; min-height: 100vh; background: #F8FAFC; }
       .main-content { flex: 1; margin-left: ${sidebarOpen? '260px' : '80px'}; transition: margin-left 0.3s ease; display: flex; flex-direction: column; }
       .content-wrapper { flex: 1; padding: 30px; }
        @media (max-width: 768px) {.main-content { margin-left: 0; } }
      `}</style>
      <div className="admin-layout">
        <Sidebar isOpen={sidebarOpen} toggle={() => setSidebarOpen(!sidebarOpen)} />
        <div className="main-content">
          <Topbar toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
          <div className="content-wrapper"><Outlet /></div>
          <Footer />
        </div>
      </div>
    </>
  );
};
export default AdminLayout;